import styled from '@emotion/styled';
import type { ReactElement } from 'react';

import LockOutlineIcon from '@/assets/svg/ui-elements/lock-outline.svg';
import { type SelectOption, Tooltip } from '@/shared/design-system';

import { DeniedReasonTrigger } from './denied-reason-trigger';

export const LOCKED_LABEL = 'Locked';

const LockMarkBox = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  color: theme.colors.text.tertiary,
}));

export const LockedMark = ({ label = LOCKED_LABEL }: { label?: string }) => (
  <LockMarkBox role="img" aria-label={label}>
    <LockOutlineIcon width={16} height={16} aria-hidden />
  </LockMarkBox>
);

export const lockedOption = (option: SelectOption): SelectOption => ({
  ...option,
  disabled: true,
  icon: <LockOutlineIcon width={16} height={16} aria-hidden />,
  supportText: LOCKED_LABEL,
});

export type LockedGateProps = {
  locked: boolean;
  reason: string;
  fullWidth?: boolean;
  children: ReactElement;
};

export const LockedGate = ({ locked, reason, fullWidth = false, children }: LockedGateProps) =>
  locked ? (
    <Tooltip title={reason}>
      <DeniedReasonTrigger denied style={fullWidth ? { width: '100%' } : undefined}>
        {children}
      </DeniedReasonTrigger>
    </Tooltip>
  ) : (
    children
  );
